var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(39.215686%,55.294118%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 39.695312 16.523438 C 39.59375 15.949219 39.46875 15.378906 39.320312 14.820312 C 39.167969 14.253906 38.992188 13.699219 38.792969 13.15625 L 38.789062 13.15625 L 33.1875 15.195312 C 33.328125 15.578125 33.453125 15.96875 33.558594 16.363281 L 27.292969 18.042969 C 27.351562 18.253906 27.398438 18.46875 27.4375 18.6875 L 33.820312 17.5625 C 33.890625 17.960938 33.945312 18.363281 33.980469 18.773438 L 39.921875 18.253906 C 39.871094 17.671875 39.796875 17.09375 39.695312 16.523438 Z M 39.695312 16.523438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(39.215686%,55.294118%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 33.820312 22.433594 C 33.75 22.839844 33.660156 23.238281 33.554688 23.632812 L 39.316406 25.171875 L 39.320312 25.171875 C 39.46875 24.613281 39.59375 24.046875 39.695312 23.46875 Z M 33.820312 22.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(39.215686%,55.294118%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 18.042969 12.703125 C 18.253906 12.644531 18.46875 12.597656 18.6875 12.558594 C 18.902344 12.523438 19.121094 12.496094 19.339844 12.476562 L 18.773438 6.019531 C 18.363281 6.054688 17.960938 6.105469 17.5625 6.175781 C 17.15625 6.246094 16.757812 6.335938 16.363281 6.441406 C 15.96875 6.546875 15.578125 6.667969 15.195312 6.808594 L 17.414062 12.902344 C 17.621094 12.828125 17.828125 12.757812 18.042969 12.703125 Z M 18.042969 12.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(39.215686%,55.294118%,89.803922%)",
      fillOpacity: 1
    },
    d: "M 16.222656 26.539062 C 16.03125 26.429688 15.847656 26.308594 15.667969 26.183594 C 15.484375 26.058594 15.3125 25.921875 15.144531 25.78125 L 10.976562 30.746094 C 10.664062 30.484375 10.363281 30.207031 10.074219 29.921875 L 14.660156 25.335938 C 14.503906 25.179688 14.355469 25.019531 14.214844 24.851562 L 9.246094 29.019531 L 4.679688 32.851562 C 5.054688 33.296875 5.445312 33.726562 5.859375 34.136719 C 6.269531 34.546875 6.699219 34.941406 7.144531 35.316406 C 7.589844 35.691406 8.050781 36.046875 8.527344 36.378906 C 9.003906 36.714844 9.496094 37.027344 9.996094 37.320312 L 9.996094 37.316406 L 12.980469 32.152344 C 13.332031 32.355469 13.695312 32.546875 14.066406 32.71875 L 16.804688 26.84375 C 16.605469 26.75 16.414062 26.648438 16.222656 26.539062 Z M 16.222656 26.539062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(11.764706%,89.019608%,81.176471%)",
      fillOpacity: 1
    },
    d: "M 31.496094 11.949219 L 36.378906 8.527344 C 36.046875 8.050781 35.691406 7.589844 35.316406 7.144531 C 34.941406 6.699219 34.550781 6.269531 34.136719 5.859375 L 29.921875 10.074219 C 30.210938 10.363281 30.484375 10.664062 30.746094 10.976562 C 31.011719 11.289062 31.257812 11.613281 31.496094 11.949219 Z M 31.496094 11.949219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(11.764706%,89.019608%,81.176471%)",
      fillOpacity: 1
    },
    d: "M 28.046875 31.492188 C 27.714844 31.726562 27.371094 31.949219 27.015625 32.152344 L 29.996094 37.316406 L 29.996094 37.320312 C 30.5 37.027344 30.988281 36.714844 31.464844 36.378906 C 31.941406 36.042969 32.402344 35.691406 32.851562 35.316406 L 29.015625 30.75 C 28.707031 31.011719 28.382812 31.257812 28.046875 31.492188 Z M 28.046875 31.492188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(11.764706%,89.019608%,81.176471%)",
      fillOpacity: 1
    },
    d: "M 26.539062 16.222656 L 32.152344 12.980469 C 31.949219 12.625 31.730469 12.28125 31.496094 11.949219 L 26.183594 15.664062 C 26.308594 15.847656 26.429688 16.03125 26.539062 16.222656 Z M 26.539062 16.222656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(11.764706%,89.019608%,81.176471%)",
      fillOpacity: 1
    },
    d: "M 18.6875 27.433594 C 18.46875 27.394531 18.253906 27.347656 18.042969 27.292969 L 16.367188 33.554688 C 15.96875 33.449219 15.578125 33.328125 15.199219 33.1875 C 14.816406 33.046875 14.4375 32.890625 14.066406 32.71875 L 11.546875 38.121094 L 11.546875 38.125 C 12.070312 38.371094 12.609375 38.59375 13.160156 38.792969 C 13.703125 38.992188 14.257812 39.167969 14.824219 39.316406 C 15.382812 39.46875 15.949219 39.59375 16.527344 39.695312 L 16.527344 39.691406 L 17.5625 33.820312 C 17.960938 33.886719 18.367188 33.941406 18.777344 33.976562 C 19.179688 34.011719 19.585938 34.03125 20 34.03125 L 20 27.546875 C 19.777344 27.546875 19.558594 27.539062 19.339844 27.519531 C 19.121094 27.5 18.902344 27.472656 18.6875 27.433594 Z M 18.6875 27.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(11.764706%,89.019608%,81.176471%)",
      fillOpacity: 1
    },
    d: "M 12.476562 20.65625 C 12.457031 20.4375 12.449219 20.21875 12.449219 19.996094 C 12.449219 19.773438 12.457031 19.554688 12.476562 19.339844 C 12.496094 19.117188 12.523438 18.898438 12.558594 18.6875 L 6.175781 17.5625 C 6.246094 17.15625 6.335938 16.757812 6.441406 16.363281 L 12.703125 18.042969 C 12.757812 17.828125 12.824219 17.621094 12.902344 17.414062 L 6.808594 15.195312 C 6.949219 14.8125 7.105469 14.433594 7.277344 14.066406 C 7.449219 13.695312 7.636719 13.335938 7.84375 12.980469 L 13.457031 16.222656 C 13.566406 16.03125 13.6875 15.847656 13.8125 15.667969 C 13.9375 15.488281 14.074219 15.3125 14.214844 15.144531 C 14.355469 14.976562 14.503906 14.816406 14.65625 14.65625 L 10.074219 10.074219 C 9.785156 10.363281 9.511719 10.664062 9.25 10.976562 C 8.984375 11.289062 8.738281 11.613281 8.5 11.949219 L 3.613281 8.527344 C 3.28125 9.003906 2.96875 9.492188 2.675781 9.996094 C 2.382812 10.5 2.113281 11.015625 1.871094 11.542969 C 1.625 12.070312 1.402344 12.605469 1.203125 13.15625 C 1.003906 13.699219 0.828125 14.253906 0.675781 14.820312 C 0.527344 15.378906 0.402344 15.949219 0.300781 16.523438 C 0.199219 17.09375 0.125 17.671875 0.0742188 18.253906 C 0.0234375 18.828125 0 19.410156 0 19.996094 C 0 20.585938 0.0234375 21.164062 0.0742188 21.742188 L 6.019531 21.21875 Z M 12.476562 20.65625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,95.686275%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 32.71875 25.929688 L 26.84375 23.1875 C 26.75 23.386719 26.648438 23.582031 26.539062 23.773438 C 26.425781 23.960938 26.308594 24.148438 26.183594 24.328125 L 31.496094 28.046875 C 31.730469 27.714844 31.949219 27.371094 32.152344 27.015625 L 37.316406 29.996094 L 37.320312 29.996094 C 37.609375 29.496094 37.878906 28.976562 38.125 28.449219 L 38.121094 28.449219 Z M 32.71875 25.929688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,95.686275%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 31.46875 3.613281 C 30.992188 3.28125 30.503906 2.96875 30 2.675781 C 29.496094 2.382812 28.980469 2.113281 28.449219 1.867188 C 27.925781 1.625 27.386719 1.402344 26.839844 1.199219 C 26.292969 1.003906 25.738281 0.828125 25.175781 0.675781 C 24.617188 0.527344 24.046875 0.402344 23.46875 0.300781 C 22.902344 0.199219 22.324219 0.125 21.742188 0.0742188 C 21.167969 0.0234375 20.585938 0 20 0 L 20 12.449219 C 20.21875 12.449219 20.4375 12.457031 20.65625 12.476562 L 21.222656 6.019531 C 21.632812 6.054688 22.035156 6.105469 22.433594 6.175781 C 22.839844 6.246094 23.238281 6.335938 23.632812 6.441406 L 21.953125 12.703125 C 22.164062 12.757812 22.375 12.824219 22.582031 12.902344 C 22.789062 12.976562 22.992188 13.0625 23.191406 13.152344 L 25.929688 7.277344 C 26.300781 7.449219 26.664062 7.640625 27.015625 7.84375 C 27.371094 8.046875 27.714844 8.265625 28.050781 8.503906 C 28.382812 8.738281 28.707031 8.984375 29.019531 9.25 L 32.855469 4.679688 C 32.40625 4.304688 31.945312 3.949219 31.46875 3.613281 Z M 31.46875 3.613281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,95.686275%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 23.632812 33.554688 C 23.238281 33.660156 22.839844 33.75 22.433594 33.820312 L 23.46875 39.691406 L 23.46875 39.695312 C 24.046875 39.59375 24.613281 39.46875 25.175781 39.320312 L 25.175781 39.3125 Z M 23.632812 33.554688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,95.686275%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 7.277344 25.929688 L 1.875 28.449219 L 1.871094 28.449219 C 2.117188 28.980469 2.386719 29.496094 2.675781 30 L 2.679688 29.996094 L 7.84375 27.015625 C 7.640625 26.664062 7.449219 26.300781 7.277344 25.929688 Z M 7.277344 25.929688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.588235%,15.686275%,27.058824%)",
      fillOpacity: 1
    },
    d: "M 27.519531 20.65625 C 27.5 20.875 27.472656 21.09375 27.4375 21.308594 L 33.820312 22.433594 C 33.890625 22.035156 33.945312 21.628906 33.980469 21.21875 Z M 27.519531 20.65625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.588235%,15.686275%,27.058824%)",
      fillOpacity: 1
    },
    d: "M 29.019531 9.25 L 24.851562 14.214844 C 25.019531 14.355469 25.183594 14.503906 25.335938 14.65625 L 29.921875 10.074219 C 29.632812 9.785156 29.332031 9.511719 29.019531 9.25 Z M 29.019531 9.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.588235%,15.686275%,27.058824%)",
      fillOpacity: 1
    },
    d: "M 22.582031 27.09375 C 22.375 27.167969 22.167969 27.234375 21.953125 27.292969 L 23.632812 33.554688 C 24.027344 33.449219 24.417969 33.328125 24.796875 33.1875 Z M 22.582031 27.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.588235%,15.686275%,27.058824%)",
      fillOpacity: 1
    },
    d: "M 14.066406 7.277344 C 14.433594 7.105469 14.8125 6.949219 15.195312 6.808594 L 13.160156 1.207031 L 13.15625 1.203125 C 12.605469 1.402344 12.070312 1.625 11.542969 1.871094 L 11.546875 1.875 Z M 14.066406 7.277344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.588235%,15.686275%,27.058824%)",
      fillOpacity: 1
    },
    d: "M 13.8125 24.328125 C 13.6875 24.148438 13.566406 23.964844 13.457031 23.773438 L 7.84375 27.015625 C 8.046875 27.367188 8.265625 27.714844 8.5 28.046875 Z M 13.8125 24.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.588235%,15.686275%,27.058824%)",
      fillOpacity: 1
    },
    d: "M 6.441406 23.632812 L 0.679688 25.171875 L 0.675781 25.171875 C 0.824219 25.738281 1 26.292969 1.199219 26.839844 L 1.203125 26.835938 L 6.804688 24.796875 C 6.667969 24.417969 6.546875 24.027344 6.441406 23.632812 Z M 6.441406 23.632812 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0b793740bab6af657d72b8cd5eb1e7f0.svg";
export { ForwardRef as ReactComponent };